import { defineStore } from 'pinia';
import {
  getListPayCalendar,
  getPayCalendarsForPeopleFilter,
} from '@apps-payroll/modules/pay-calendar/requests/webapp/get-list-pay-calendar';
import { PayCalendar } from '@apps-payroll/modules/pay-calendar/types';

export const usePayCalendarStore = defineStore('people/pay-calendar', {
  state: () => ({
    payCalendarsIndexed: {} as Record<number, PayCalendar>,
    filterPayCalendars: [] as PayCalendar[],
    filterCalendarsLoading: false,
    filterCalendarsLoadFailed: false,
  }),
  actions: {
    async fetchFilterPayCalendars(): Promise<void> {
      if (this.filterCalendarsLoading) {
        return;
      }

      this.filterCalendarsLoading = true;
      this.filterCalendarsLoadFailed = false;
      try {
        const calendars = await getPayCalendarsForPeopleFilter();
        this.filterPayCalendars = calendars.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      } catch (e) {
        this.filterCalendarsLoadFailed = true;
      } finally {
        this.filterCalendarsLoading = false;
      }
    },
    async fetchPayCalendars(): Promise<void> {
      try {
        const payCalendars = await getListPayCalendar();
        this.payCalendarsIndexed = payCalendars.reduce(
          (reduced: Record<number, PayCalendar>, calendar) => {
            reduced[calendar.id] = calendar;
            return reduced;
          },
          {}
        );
      } catch (e) {
        console.error(e);
      }
    },
    getPayCalendarById(id: number): PayCalendar | undefined {
      return this.payCalendarsIndexed[id];
    },
  },
});
